import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appCvvFormat]'
})
export class CvvFormatDirective {
  @Input() cardType: string = '';
  constructor(private control: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: any) {
    let input = event.target.value;
    // Remove non-numeric characters
    input = input.replace(/\D/g, '');
    // Determine CVV length based on card type
    const cvvLength = this.cardType === 'amex' ? 4 : 3;
    // Limit CVV length
    if (input.length > cvvLength) {
      input = input.slice(0, cvvLength);
    }
    // Update the input value
    event.target.value = input;
  }
}
